(function () {
  'use strict';

  // Only Shopify's Theme Editor preview sets window.Shopify.designMode to
  // true. This bridge exists purely to power click-to-edit inside that
  // editor; real shoppers never have anything for it to sync. Skipping it
  // outside the editor removes the repeated no-op polling it used to run
  // on every live page load, with no change to how it behaves inside the
  // editor itself.
  function inEditor() {
    return Boolean(window.Shopify && window.Shopify.designMode);
  }

  var TARGETS = {
    header: function () { return document.querySelector('#main-header'); },
    hero: function () {
      var titleBtn = document.querySelector('#hero-shop-now-btn');
      return titleBtn ? titleBtn.closest('section') : null;
    },
    banner: function (index) {
      return document.getElementById('offer-' + (index + 1));
    },
    category: function (index) {
      var cards = Array.prototype.slice.call(document.querySelectorAll('[data-category-card]'));
      return cards[index] || null;
    },
    featured: function () { return document.querySelector('#featured-products-section'); },
    flash_sale: function () {
      var headings = Array.prototype.slice.call(document.querySelectorAll('h2'));
      for (var i = 0; i < headings.length; i += 1) {
        if (/LIFASE Cyber Flash Sale/i.test(headings[i].textContent || '')) {
          return headings[i].closest('section');
        }
      }
      return null;
    },
    trust: function () { return document.querySelector('#trust-section'); },
    reviews: function () { return document.querySelector('#reviews-section'); },
    newsletter: function () { return document.querySelector('#newsletter-section'); },
    footer: function () { return document.querySelector('#main-footer'); }
  };

  function value(block, key) {
    var el = block.querySelector('[data-setting="' + key + '"]');
    return el ? el.textContent.trim() : '';
  }

  function setShopifyAttrs(target, source) {
    if (!target || !source) return;
    Array.prototype.slice.call(source.attributes || []).forEach(function (attr) {
      if (/^data-shopify-editor-/.test(attr.name) || attr.name === 'data-block-id' || attr.name === 'data-block-type') {
        target.setAttribute(attr.name, attr.value);
      }
    });
  }

  function applyText(el, text) {
    if (el && text) el.textContent = text;
  }

  function applyHero(block, target) {
    if (!target) return;
    var badge = target.querySelector('.inline-flex span');
    var subtitle = target.querySelector('p');
    var heading = target.querySelector('h1');
    applyText(badge, value(block, 'badge'));
    applyText(subtitle, value(block, 'subtitle'));
    if (heading) {
      var before = value(block, 'title_before') || 'Smart Products.';
      var after = value(block, 'title_after') || 'Better Living.';
      heading.innerHTML = '';
      var span = document.createElement('span');
      span.textContent = before;
      heading.appendChild(span);
      heading.appendChild(document.createTextNode(' '));
      var hi = document.createElement('span');
      hi.className = 'text-transparent bg-clip-text bg-gradient-to-r from-slate-900 via-[#0077b6] to-[#00b4d8]';
      hi.textContent = after;
      heading.appendChild(hi);
    }
  }

  function applyBanner(block, target) {
    if (!target) return;
    var spans = target.querySelectorAll('span');
    var highlight = value(block, 'discount_highlight');
    var badge = value(block, 'badge');
    var title = value(block, 'title');
    var description = value(block, 'description');
    var cta = value(block, 'cta_text');
    var img = target.querySelector('img');
    var h2 = target.querySelector('h2');
    var p = target.querySelector('p');
    var button = target.querySelector('button');
    if (spans[0] && highlight) spans[0].textContent = highlight;
    if (spans[1] && badge) spans[1].textContent = badge;
    applyText(h2, title);
    applyText(p, description);
    if (button && cta) {
      var textNode = Array.prototype.slice.call(button.childNodes).find(function (n) { return n.nodeType === 3 || (n.nodeType === 1 && n.tagName === 'SPAN'); });
      if (textNode) {
        if (textNode.nodeType === 3) textNode.textContent = cta + ' ';
        else textNode.textContent = cta;
      }
    }
    var imageUrl = value(block, 'image');
    if (img && imageUrl) img.src = imageUrl;
  }

  function applyCategory(block, target) {
    if (!target) return;
    var img = target.querySelector('img');
    var h3 = target.querySelector('h3');
    var paras = target.querySelectorAll('p');
    var imageUrl = value(block, 'image');
    var title = value(block, 'title');
    var tagline = value(block, 'tagline');
    if (img && imageUrl) img.src = imageUrl;
    applyText(h3, title);
    if (paras.length) applyText(paras[paras.length - 1], tagline);
  }

  function applySimple(block, target, kind) {
    if (!target) return;
    var heading = target.querySelector('h2');
    var desc = target.querySelector('p');
    if (kind === 'header') {
      var logo = target.querySelector('#lifase-brand-logo-btn img, img[alt*=LIFASE i]');
      var logoUrl = value(block, 'logo');
      if (logo && logoUrl) logo.src = logoUrl;
      return;
    }
    if (kind === 'featured' || kind === 'flash_sale' || kind === 'reviews' || kind === 'newsletter') {
      applyText(heading, value(block, 'heading'));
    }
    if (kind === 'flash_sale' || kind === 'newsletter') {
      applyText(desc, value(block, 'description'));
    }
  }

  function sync() {
    var root = document.getElementById('root');
    if (!root) return;
    var editorBlocks = document.querySelectorAll('[data-lifase-editor-block]');
    var typeCounts = {};
    Array.prototype.forEach.call(editorBlocks, function (block) {
      var type = block.getAttribute('data-block-type');
      var typeIndex = typeCounts[type] || 0;
      typeCounts[type] = typeIndex + 1;
      var target = TARGETS[type] ? TARGETS[type](type === 'banner' || type === 'category' ? typeIndex : undefined) : null;
      if (!target) return;
      setShopifyAttrs(target, block);
      if (type === 'hero') applyHero(block, target);
      else if (type === 'banner') applyBanner(block, target);
      else if (type === 'category') applyCategory(block, target);
      else applySimple(block, target, type);
    });
  }

  function ready() {
    if (!inEditor()) return;
    sync();
    var tries = 0;
    var timer = setInterval(function () {
      sync();
      tries += 1;
      if (tries > 40) clearInterval(timer);
    }, 150);
  }

  document.addEventListener('DOMContentLoaded', ready);
  document.addEventListener('shopify:section:load', ready);
  document.addEventListener('shopify:section:reorder', ready);
  document.addEventListener('shopify:block:select', ready);
  document.addEventListener('shopify:block:deselect', ready);
  window.addEventListener('load', ready);
})();
